import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import Accordion from 'components/Accordion';
import RegistrationForm from './RegistrationForm';

type Props = {
  defaultExpanded?: boolean;
}

const Registration:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full" react-scroll="registration">
      <Accordion label={t('pages.quizForm.registrationLabel')} icon="user_check" previewPage="register" defaultExpanded={defaultExpanded}>
        <RegistrationForm />
      </Accordion>
    </div>
  )
}

export default Registration;
